import { View } from "binder"
import { BpmnEditorViewModel } from "./bpmnEditor-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { BpmnElement, BpmnElementCreator } from "./editor";

export class BpmnEditorView extends View<BpmnEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-D47232F2-E8E3-4AD9-81C2-3313CF0DADFA"
    }
    loadHtml(): string {
        let element = require('./bpmnEditor.html').default;
        let style = require('./bpmnEditor.less');
        return element;
    }
    constructor() {
       super();
       new BpmnElementCreator().create();
    }

    public set drawing(v: boolean) { this._drawing = v; } public get drawing(): boolean { return this._drawing;} private _drawing: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
    public set xml(v: string) { 
        this._xml = v; 
        this.draw();
    } public get xml(): string { return this._xml;} private _xml: string;
    async draw(){
        if(this.firstlevelElement==null)
            return;
        if(this.editor==null)
            return;
        if(this.editor.setXml)
            this.editor.setXml(this.xml);
    }

    private diagramChanges(){
        this.dataContext.diagramChanges();
    }
    public override onDataContextSet(){
        this.dataContext.updateXml = this.updateXml.bind(this);
    }
    async updateXml():Promise<any>{
        var result = await this.editor.getXml();
        this.xml = result.xml;
    }
    save(){
        this.dataContext.save();
    }
    private editor : BpmnElement;
    public override onRenderCompleted(){
        this.editor = this.firstlevelElement.querySelector('bpmn-editor-element');
        this.editor.elementChoosed = this.elementChoosed.bind(this);
        this.editor.diagramChanges = this.diagramChanges.bind(this);
        this.draw();
    }
    public elementChoosed(element){
        if(this.drawing){
            return;
        }
        if(element.type=='bpmn:UserTask'){
            this.dataContext.editUserTask(element.id);
        }else if(element.type=='bpmn:ScriptTask'){
            this.dataContext.editScriptTask(element.id);
        }else if(element.type=='bpmn:SequenceFlow'){
            this.dataContext.editSequenceFlow(element.id)
        }else if(element.type=='bpmn:SendTask'){
            this.dataContext.editScriptTask(element.id);
        }else if(element.type=='bpmn:ReceiveTask'){
            this.dataContext.editReceiveTask(element.id);
        }else if(element.type=='bpmn:IntermediateCatchEvent' && element.businessObject.eventDefinitions && element.businessObject.eventDefinitions.length>0 && element.businessObject.eventDefinitions[0].$type=="bpmn:TimerEventDefinition"){
            this.dataContext.editIntermediateTimerEvent(element.id);
        }else if(element.type=='bpmn:StartEvent' && element.businessObject.eventDefinitions && element.businessObject.eventDefinitions.length>0 && element.businessObject.eventDefinitions[0].$type=="bpmn:TimerEventDefinition"){
            this.dataContext.editStartTimerEvent(element.id);
        }else{
            this.dataContext.editDefault(element.id);
        }
    }
}
